import React from "react";

const About = () =>{
        return(
            <>
                <h1>Welcome to about page</h1>
            </>
        );
}

export default About;